import type { GridColDef } from "@mui/x-data-grid-premium";
import type { ReportingPeriod } from "@entrilia/shared/api/dataCollectionTypes";
import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import DataSubmissionStatusTag from "@entrilia/shared/components/dataCollection/DataSubmissionStatusTag";
import FormattedDueDate from "@entrilia/shared/components/dataCollection/FormattedDueDate";
import { convertISODate, convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import { reportingPeriodCaptionsMap } from "@entrilia/shared/utilities/enumCaptions";
import type { DataCollectionSubmissionInfo } from "../../api/types/dataCollectionTypes";

export const columnDefinitions: GridColDef<DataCollectionSubmissionInfo>[] = [
  {
    field: "requestName",
    headerName: "Name",
    flex: 1.5,
    minWidth: 200,
    renderCell: ({ row }) => <GridTextHoverLink to={`submissions/${row.id}`} text={row.requestName} />,
  },
  {
    field: "requestTemplateName",
    headerName: "Type",
    flex: 1,
    minWidth: 160,
  },
  {
    field: "recipientName",
    headerName: "Portfolio Company",
    flex: 1,
    minWidth: 160,
  },
  {
    field: "reportingDate",
    headerName: "Reporting Date",
    flex: 0.5,
    minWidth: 120,
    valueFormatter: (value: string) => convertISODate(value),
  },
  {
    field: "reportingPeriod",
    headerName: "Period",
    flex: 0.5,
    minWidth: 120,
    valueFormatter: (value: ReportingPeriod) => reportingPeriodCaptionsMap[value],
  },
  {
    field: "status",
    headerName: "Status",
    flex: 0.5,
    minWidth: 160,
    renderCell: ({ row }) => <DataSubmissionStatusTag status={row.status} />,
  },
  {
    field: "dueDate",
    headerName: "Due Date",
    flex: 0.5,
    minWidth: 120,
    renderCell: ({ row }) =>
      row.status === "Completed" ? convertISODate(row.dueDate) : <FormattedDueDate dueDateIsoString={row.dueDate} />,
  },
  {
    field: "submittedBy",
    headerName: "Submitted by",
    flex: 1,
    minWidth: 160,
  },
  {
    field: "submittedAt",
    headerName: "Submitted at",
    flex: 0.5,
    minWidth: 160,
    valueFormatter: (value: string | undefined) => convertISODateTime(value),
  },
];
